export default function AOI() {
  return (
    <div>aoi</div>
  )
}